import cn from 'classnames';
import React from 'react';

import { PriceFormat } from '../price-format/price-format';

import styles from './old-price.module.scss';

export const OldPrice: React.FC<{
  price: number | string;
  className?: string;
}> = ({ price, className }) => (
  <span className={cn(className, styles.oldPrice)}>
    Was{' '}
    <span>
      <PriceFormat value={price} prefix="R" />
    </span>
  </span>
);
